import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { BUTTON_TYPE } from '~/components/ui/button';
import { TITLE_TYPE } from '~/components/ui/title';
import { PATH } from '~/constants/route-path';
import {
  StyledBackgroundImage,
  StyledButton,
  StyledContainer,
  StyledContent,
  StyledImage,
  StyledTitle,
} from '~/pages/HomePage/components/try-our-qr-code/styled';
import { COLORS } from '~/styles/colors';

import backgroundImg from './assets/background.webp';
import tryOurQrImg from './assets/try-our-qr-code-image.webp';

export default function TryQrCodePoster() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate(PATH.SIGN_UP);
  };

  return (
    <StyledContainer>
      {/*<div>*/}
      <StyledBackgroundImage src={backgroundImg} alt="background" />
      <StyledContent>
        <StyledTitle type={TITLE_TYPE.h2}>{t('landing:tryQrCode.title')}</StyledTitle>
        <StyledButton
          type={BUTTON_TYPE.contained}
          backgroundColor={COLORS.white}
          color={COLORS.primary}
          hoverBackgroundColor={COLORS.white}
          onClick={handleSignUp}
        >
          {t('landing:createFreeAccount')}
        </StyledButton>
      </StyledContent>
      <StyledImage src={tryOurQrImg} alt="try-our-qr-code" />
      {/*</div>*/}
    </StyledContainer>
  );
}
